// IM 平台分类
export const CHINA_IM_PLATFORMS = ['dingtalk', 'feishu', 'wechatwork', 'qq'] as const;
export const GLOBAL_IM_PLATFORMS = ['telegram', 'discord'] as const;

/**
 * 根据语言获取可见的 IM 平台
 */
export const getVisibleIMPlatforms = (_language: 'zh' | 'zh-TW' | 'en'): readonly string[] => {
  return [...CHINA_IM_PLATFORMS, ...GLOBAL_IM_PLATFORMS];
};

/** Web 机器人配置页实际支持的平台；目录中的其他 IM 不应显示可用的配置按钮。 */
export function supportsWebIMConfiguration(platform: string): boolean {
  return [...CHINA_IM_PLATFORMS, ...GLOBAL_IM_PLATFORMS, 'wechat'].includes(platform.toLowerCase());
}
